import React, { useState, useEffect } from "react";
import logServices from "../Services/logService";
import Loading from "../Modals/Loading";

const Logs = () => {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        const data = await logServices.fetchAllLogs();
        setLogs(data.logs);
      } catch (error) {
        console.error("Error fetching logs:", error);
        setLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  return (
    <div className="mx-10 p-8 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <div>
        <h1 className="text-3xl font-bold text-secondary">Logs</h1>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          {logs.length > 0 ? (
            <div className="table-div">
              <table className="w-full">
                <thead>
                  <tr className="border-y-2 text-left w-full text-black font-bold text-[10px]">
                    <th className="py-4 text-center">User ID</th>
                    <th className="py-4 text-center">Reference ID</th>
                    <th className="py-4 text-center">Entity</th>
                    <th className="py-4 text-center">Page</th>
                    <th className="py-4 text-center">Action</th>
                    <th className="py-4 text-center">Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length > 0 ? (
                    logs.map((log) => (
                      <tr
                        key={log.id}
                        className="bg-accent border-gray-200 border-b text-[10px]"
                      >
                        <td className="py-4 text-center">{log.user_id}</td>
                        <td className="py-4 text-center">{log.ref_id}</td>
                        <td className="py-4 text-center">{log.entity}</td>
                        <td className="py-4 text-center">{log.page}</td>
                        <td className="py-4 text-center">{log.action}</td>
                        <td className="py-4 text-center">
                          {new Date(log.created_at).toLocaleString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        className="text-center py-6 text-gray-500"
                      >
                        No logs found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center py-6 text-gray-500">No logs found</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Logs;
